/* eslint-disable no-negated-condition */
/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { CREATE_GRADE, UPDATE_GRADE } from 'pages/Products/ProductsGraphQL';
import {
  getGradeInitialValues,
  gradeInitialValues,
  gradeValidationSchema,
} from 'pages/Products/constant';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { authContext } from 'contexts/AuthContext';
import ErrorBoundary from 'components/common/ErrorBoundary';
import AddEditCategoryGradeForm from './components/AddEditCategoryGradeForm';

const AddEditCategoryGrade = ({
  toggleAddRecord,
  type,
  currentRow,
  refetch,
}) => {
  const { auth } = useContext(authContext);
  const [createGrade] = useMutation(CREATE_GRADE, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.createGrade);
      toggleAddRecord('', '');
      if (refetch) {
        refetch();
      }
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [updateGrade] = useMutation(UPDATE_GRADE, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.updateGrade);
      toggleAddRecord();
      if (refetch) {
        refetch();
      }
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });
  const handleSubmit = async (val) => {
    const values = { ...val };

    if (values?.category?.id) {
      delete values?.category;
    }
    if (type !== ADD_EDIT_CONSTANT.EDIT) {
      try {
        await createGrade({
          variables: {
            grade: {
              ...values,
              // category: values.category.id,
              createdBy: auth?.data?.userId,
              subCategory: values.subCategory?.id,
              gradeType: values?.gradeType?.id,
              isApproved: true,
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    } else {
      try {
        await updateGrade({
          variables: {
            grade: {
              ...values,
              // category: values.category.id,
              createdBy: auth?.data?.userId,
              subCategory: values.subCategory?.id,
              gradeType: values?.gradeType?.id,
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    }
  };
  return (
    <div>
      <ErrorBoundary>
        <Formik
          enableReinitialize
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? getGradeInitialValues(currentRow)
              : gradeInitialValues
          }
          validationSchema={gradeValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditCategoryGradeForm
                toggleAddRecord={toggleAddRecord}
                type={type}
                {...props}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditCategoryGrade;
